import { Box, Drawer } from '@mui/material';
import ReportDisclaimer from './ReportDisclaimer';
import { CompoundCardProps, DisplayDetailsForValue } from '../types/reports';
import CompoundDetailsResult from './CompoundDetailsResult';
import { useThemeContext } from '../contexts/BaseThemeContextProvider';

type ReportDescriptionDrawerProps = {
  detectionFrequency: string;
  ddfv: DisplayDetailsForValue | null;
  open: boolean;
  onClose: () => void;
  setIsCompoundDetailsLoading: (value: boolean) => void;
  compoundDataList: CompoundCardProps[];
};

const ReportDescriptionDrawer = ({
  detectionFrequency,
  ddfv,
  open,
  onClose,
  setIsCompoundDetailsLoading,
  compoundDataList,
}: ReportDescriptionDrawerProps) => {
  const { theme } = useThemeContext();
  const selectedCompoundIndex = compoundDataList.findIndex(
    (compound) => compound.ddfv?.testNameAbbr === ddfv?.testNameAbbr,
  );

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: 'transparent',
          width: '100%',
          maxWidth: '889px',
          padding: 0,
        },
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '100%',
          backgroundColor: theme.custom.report.details.resultTable.drawer.backgroundColor,
          padding: '40px 24px',
          boxSizing: 'border-box',
          position: 'relative',
          overflowY: 'auto',
        }}
      >
        <img
          src={theme.custom.report.details.resultTable.drawer.closeIcon}
          alt="Close"
          onClick={onClose}
          style={{
            position: 'absolute',
            right: 20,
            top: 14,
            cursor: 'pointer',
            width: '24px',
            height: '24px',
          }}
        />

        <CompoundDetailsResult
          showPagination={false}
          setIsDescComponentOpen={() => {}}
          detectionFreq={detectionFrequency}
          setSelectedCompoundIndex={() => {}}
          selectedCompoundIndex={selectedCompoundIndex}
          sortedCompoundDataList={compoundDataList}
          setIsCompoundDetailsLoading={setIsCompoundDetailsLoading}
        />

        {/* Disclaimer Section */}
        <ReportDisclaimer />
      </Box>
    </Drawer>
  );
};

export default ReportDescriptionDrawer;
